import React, { ReactNode } from 'react'
import { MVPButton } from '../../Buttons/MVPButton'
import './BasicModal.scss'

export interface BasicModalViewProps
{
	title: string
	text: string | ReactNode
	confirmTitle: string
	clickConfirm?: () => void
}

export const BasicModalView : React.FC<BasicModalViewProps> = ({ title, text, confirmTitle, clickConfirm }) =>
{
	return (
		<>
			<span className='modal-title'>{title}</span>
			<span className='modal-subtitle'>{text}</span>
			<div className='buttons'>
				<MVPButton onClick={() => clickConfirm?.()}>{confirmTitle}</MVPButton>
			</div>
		</>
	)
}
